<template>
  <div class="view-next-releases">
    <h5 class="text-semibold mb-5">Próximos lançamentos</h5>
    <snow-data-table-header
      @add="addRealease"
      addText="Adicionar lançamento"
      :filters="false"
      :datePicker="false"
      @searching="searching"
    />

    <div class="my-9 text-center" v-if="loading">
      <b-spinner variant="primary" />
    </div>

    <snow-data-table v-else :columns="columns" :data="releases">
      <template #no-content-actions>
        <div class="d-flex flex-column align-items-center gap-4">
          <snow-button
            text="Cadastrar novo lançamento"
            icon="ph ph-plus"
            @click="addRealease"
          />
          <h5 class="text-dark-40">
            Informe seus alunos sobre o que está por vir
          </h5>
        </div>
      </template>
    </snow-data-table>
  </div>
</template>

<script>
import { clearObject } from "@/functions/helpers";
import { mapState } from "vuex";

import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      search: ""
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("membersReleases", ["releases", "pagination"]),
    columns() {
      return [
        {
          name: "Nome",
          field: "title"
        },
        {
          name: "Produto",
          field: "name"
        },
        {
          name: "Link do produto",
          field: "url",
          type: "link"
        },
        {
          name: "Data do lançamento",
          field: "release_at",
          transform: this.formatDate
        },
        {
          name: "Hora do lançamento",
          field: "release_at",
          transform: this.formatTime
        },
        {
          name: "Data de encerramento",
          field: "expires_in",
          transform: this.formatDate
        },
        {
          name: "Status",
          field: "is_active",
          transform: this.formatStatus,
          class: this.formatStatusClass
        },
        {
          name: "",
          type: "menu",
          options: this.getActions
        }
      ];
    }
  },
  mounted() {
    this.dispatch();
  },
  methods: {
    dispatch() {
      let params = { search: this.search };

      this.loading = true;
      this.$store
        .dispatch("membersReleases/get", clearObject(params))
        .catch(error => {
          this.$message.error("Não foi possível carregar os lançamentos");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searching(value) {
      this.search = value;
      this.dispatch();
    },
    addRealease() {
      this.$router.push({ name: "register-releases" });
    },
    formatStatus(_, item) {
      if (item.is_expired) return "Expirado";
      return item.is_active ? "Ativo" : "Inativo";
    },
    formatStatusClass(_, item) {
      if (item.is_expired) return "expired-badge";
      return item.is_active ? "active-badge" : "inactive-badge";
    },
    formatDate(value) {
      return moment.utc(value).format("DD/MM/YYYY");
    },
    formatTime(value) {
      return moment.utc(value).format("HH:mm");
    },
    getActions(item) {
      return [
        {
          label: "Editar",
          click: this.editItem
        },
        {
          label: item.is_active ? "Desativar" : "Ativar",
          click: this.changeStatus
        },
        {
          label: "Excluir",
          class: "text-danger",
          variant: "danger",
          dialog: {
            text: "Deseja mesmo excluir este lançamento?",
            buttonText: "Sim, excluir",
            icon: "ph ph-trash",
            secondaryButtonText: "Cancelar",
            action: this.deleteItem
          }
        }
      ];
    },
    changeStatus(item) {
      let { id, is_active } = item;
      let data = { id, is_active: !is_active };

      this.$store
        .dispatch("membersReleases/put", data)
        .then(() => {
          this.dispatch();
          this.$message.success(
            `Lançamento ${data.is_active ? "ativado" : "desativado"}!`
          );
        })
        .catch(() => {
          this.$message.error(
            "Não foi possível alterar o status do lançamento"
          );
        });
    },
    deleteItem(item) {
      this.$store
        .dispatch("membersReleases/delete", item.id)
        .then(() => {
          this.dispatch();
          this.$message.success("Lançamento removido");
        })
        .catch(() => {
          this.$message.error("Não foi possível deletar o lançamento");
        });
    },
    editItem(item) {
      this.$router.push({ name: "register-releases", params: { id: item.id } });
    }
  }
};
</script>
